import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20composition%20with%20warm%20orange%20and%20deep%20charcoal%20gradient%2C%20flowing%20ink-like%20shapes%20inspired%20by%20manga%20and%20manhwa%20aesthetics%2C%20dramatic%20lighting%20with%20subtle%20texture%2C%20modern%20minimalist%20design%2C%20no%20text%2C%20smooth%20gradients%2C%20cinematic%20wide%20composition&width=1800&height=620&seq=hero-bg-01&orientation=landscape"
        alt="韩漫画网 - 韩漫免费在线阅读平台"
        title="韩漫免费看 - 下拉式漫画大全"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 tracking-wide">
          韩漫免费看
        </h1>
        <p className="text-base md:text-lg text-white/85 max-w-2xl mb-8 leading-relaxed">
          下拉式漫画大全，畅享韩国漫画在线阅读体验。海量韩漫资源，每日更新，随时随地轻松追漫。
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-4">
          <Link
            to="/category/all"
            className="px-8 py-3 rounded-full bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            立即探索
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/category/romance"
            className="px-8 py-3 rounded-full border border-white/40 text-white font-medium text-sm hover:bg-white/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            热门恋爱
          </Link>
        </div>

        <div className="mt-12 flex items-center gap-8 md:gap-12">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-white">500+</div>
            <div className="text-xs md:text-sm text-white/70 mt-1">漫画资源</div>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-white">100万+</div>
            <div className="text-xs md:text-sm text-white/70 mt-1">活跃读者</div>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-white">每日更新</div>
            <div className="text-xs md:text-sm text-white/70 mt-1">持续连载</div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white/60 text-2xl"></i>
      </div>
    </section>
  );
}